import { Box, Typography } from '@mui/material';
import React, { FC, ReactElement } from 'react';

interface Props {
    label: ReactElement | string;
    value?: ReactElement | string;
}

export const LabelValue: FC<Props> = ({ label, value, ...props }) => {
    return (
        <Box {...props}>
            <Typography variant="caption" mb={0}>
                {label}
            </Typography>
            {value ? (
                <>{typeof value === 'string' ? <Typography>{value || '-'}</Typography> : <Box>{value}</Box>}</>
            ) : (
                <Typography>{'-'}</Typography>
            )}
        </Box>
    );
};
